import {SearchOutlined} from '@ant-design/icons';
import React, {useRef} from 'react';
import DebouncingInput from '../../elements/DebouncingInput';
import {useSelector} from "react-redux";


const SearchFilterTableNumber = () => {
    const searchInput = useRef(null);
    const filter = useSelector((state) => state.TableRedux.filter);

    const getColumnSearchPropsNumber = (placeholder = 'جستجو...', initialValue, callbackData,number,dataIndex) => ({
        filterDropdown: (/*{setSelectedKeys, selectedKeys, confirm,  clearFilters}*/) => (<div
            style={{
                padding: 8, width: '180px'
            }}
        >
            <DebouncingInput max={number}  allowClear ref={searchInput} defaultValue={initialValue}
                             onChange={(value) => {
                                 if (value.length === number || value.length === 0) {

                                     callbackData(value)

                                 }
                             }}
                             placeholder={placeholder}/>


        </div>), filterIcon: (filtered) => (<SearchOutlined
            style={{
                color: filter[dataIndex] ? 'blue'   : undefined,
            }}
        />), onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
    });


    return [getColumnSearchPropsNumber];
};

export default SearchFilterTableNumber;